var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, UpdateDateColumn } from 'typeorm';
import { getLongTextEntityType } from '@/common/config';
let RawTransaction = class RawTransaction {
    id;
    txDigest;
    checkpoint;
    data;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], RawTransaction.prototype, "id", void 0);
__decorate([
    Column(),
    Index({ unique: true }),
    __metadata("design:type", String)
], RawTransaction.prototype, "txDigest", void 0);
__decorate([
    Column('bigint'),
    Index(),
    __metadata("design:type", String)
], RawTransaction.prototype, "checkpoint", void 0);
__decorate([
    Column(getLongTextEntityType()),
    __metadata("design:type", String)
], RawTransaction.prototype, "data", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], RawTransaction.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], RawTransaction.prototype, "createdAt", void 0);
RawTransaction = __decorate([
    Entity({ name: 'raw_transaction' })
], RawTransaction);
export { RawTransaction };
//# sourceMappingURL=module.js.map